export interface PagedResponse<T> {
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    items: T[];
}

export const DefaultPagedResponse: PagedResponse<any> = {
    page: 0,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
    items: [],
};
